const CopySvg = ({ size = '14px' }) => (
  <svg
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    className={`-m-[3px] ml-1 size-[${size}]`}
  >
    <path
      d="M4.8125 4.875V4.06313C4.8125 3.40106 5.30541 2.83926 5.96522 2.78449C6.18296 2.76642 6.40142 2.75084 6.62055 2.73778M9.1875 11H10.5C11.2249 11 11.8125 10.4124 11.8125 9.6875V4.06313C11.8125 3.40105 11.3196 2.83926 10.6598 2.78449C10.442 2.76642 10.2236 2.75084 10.0044 2.73778M9.1875 11.4375V10.3438C9.1875 9.25644 8.30606 8.375 7.21875 8.375H6.34375C5.98131 8.375 5.6875 8.08119 5.6875 7.71875V6.84375C5.6875 5.75644 4.80606 4.875 3.71875 4.875H3.0625M10.0044 2.73778C9.83923 2.20191 9.34009 1.8125 8.75 1.8125H7.875C7.28491 1.8125 6.78577 2.20191 6.62055 2.73778M10.0044 2.73778C10.0422 2.86018 10.0625 2.99022 10.0625 3.125V3.5625H6.5625V3.125C6.5625 2.99022 6.58282 2.86018 6.62055 2.73778M3.9375 4.875H2.84375C2.48131 4.875 2.1875 5.16881 2.1875 5.53125V12.5312C2.1875 12.8937 2.48131 13.1875 2.84375 13.1875H8.53125C8.89369 13.1875 9.1875 12.8937 9.1875 12.5312V10.125C9.1875 7.22551 6.83699 4.875 3.9375 4.875Z"
      stroke="#fffffff"
      strokeWidth="0.875"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CopySvg;
